export type UnassignedAction = 'Approved assignment' | 'Approved to deactivate'

export type ProductStatus = 'Active' | 'Inactive'

export type UnassignedProduct = {
  sku: string
  title: string
  /** Catalog status after the cleanup decision was applied. */
  status: ProductStatus
  action: UnassignedAction
  /** Destination in the restructured tree, or the deactivation decision. */
  suggestion: string
  note: string
}

/**
 * Internal audit list of root-only / unassigned products and the decisions
 * logged for each. Report-only — this bucket is never exposed in
 * customer-facing navigation, category cards, or sample product grids.
 *
 * Order matches the Codex category structure report: approved category
 * assignments first, then products approved for deactivation.
 */
export const UNASSIGNED_PRODUCTS: UnassignedProduct[] = [
  {
    sku: 'MB404',
    title: 'Decorative Cedar Top Mount Post MB404',
    status: 'Active',
    action: 'Approved assignment',
    suggestion: 'Mailboxes > Mailbox Posts > Cedar Mailbox Posts',
    note: 'Cedar post fits the existing cedar mailbox post assortment.',
  },
  {
    sku: '7006',
    title: 'Mail Boss 7006 Surface Mount Mailbox Post Granite',
    status: 'Active',
    action: 'Approved assignment',
    suggestion: 'Mailboxes > Mailbox Posts > Mailboss Post',
    note: 'Surface mount Mail Boss post, grouped with the Mailboss line.',
  },
  {
    sku: '7007',
    title: 'Mail Boss 7007 Surface Mount Mailbox Post -Black',
    status: 'Active',
    action: 'Approved assignment',
    suggestion: 'Mailboxes > Mailbox Posts > Mailboss Post',
    note: 'Surface mount Mail Boss post, grouped with the Mailboss line.',
  },
  {
    sku: '7008',
    title: 'Mail Boss 7008 Surface Mount Mailbox Post White',
    status: 'Active',
    action: 'Approved assignment',
    suggestion: 'Mailboxes > Mailbox Posts > Mailboss Post',
    note: 'Surface mount Mail Boss post, grouped with the Mailboss line.',
  },
  {
    sku: '7009',
    title: 'Mail Boss 7009 Surface Mount Mailbox Post Bronze',
    status: 'Active',
    action: 'Approved assignment',
    suggestion: 'Mailboxes > Mailbox Posts > Mailboss Post',
    note: 'Surface mount Mail Boss post, grouped with the Mailboss line.',
  },
  {
    sku: 'LTO-1302',
    title: 'QualArc Edgewood Lighted Address Plaque',
    status: 'Active',
    action: 'Approved assignment',
    suggestion:
      'Outdoor Accessories & Home Accents > Address Plaques & House Numbers > Illuminated Address Plaques',
    note: 'Lighted plaque belongs with the illuminated address plaque grouping.',
  },
  {
    sku: '14247',
    title: 'Whitehall Illuminator Solar Address Lamp 14247',
    status: 'Active',
    action: 'Approved assignment',
    suggestion:
      'Outdoor Accessories & Home Accents > Address Plaques & House Numbers > Illuminated Address Plaques',
    note: 'Solar address lamp belongs with the illuminated address plaque grouping.',
  },
  {
    sku: '02252',
    title: '22x36 Mat - Holly Ivy Border/Monogrammed',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Mat product retired with the Door Mats & Welcome Mats branch.',
  },
  {
    sku: '15000BR',
    title: 'Bacova American Classic Oval Monogram Burgundy',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Mat product retired with the Door Mats & Welcome Mats branch.',
  },
  {
    sku: '15090BR',
    title: 'Bacova Quiet Mill Burgundy Oval',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Mat product retired with the Door Mats & Welcome Mats branch.',
  },
  {
    sku: '15437FG',
    title: 'Bacova Tropy Deer Oval',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Mat product retired with the Door Mats & Welcome Mats branch.',
  },
  {
    sku: 'NOBH-20EL',
    title: 'Personal 1.0 cu ft Safe',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Safe product outside the mailbox, signage, and exterior lines.',
  },
  {
    sku: 'NOCH-11EL',
    title: 'Drawer Safe',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Safe product outside the mailbox, signage, and exterior lines.',
  },
  {
    sku: 'NOCH-25EL',
    title: 'Personal .5 cu ft Safe',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Safe product outside the mailbox, signage, and exterior lines.',
  },
  {
    sku: 'NOCH-46EL',
    title: 'Personal 2.0 cu ft Safe',
    status: 'Inactive',
    action: 'Approved to deactivate',
    suggestion: 'Inactive — removed from the catalog',
    note: 'Safe product outside the mailbox, signage, and exterior lines.',
  },
]
